// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader[data-v-6def92cf]{width:100%;height:250px;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
